export default __webpack_public_path__ + "img/github.f7165d3e.svg";